import type { LandingTokens } from '../types';

export const editorialTokens: LandingTokens = {
  brand: '#50bcd7',
  brandInk: '#23606f',
  ink: '#101820',
  inkSoft: '#22303a',
  onDark: '#f4f1ea',
  paper: '#faf7f2',
  paperHi: '#ffffff',
  line: 'rgba(16,24,32,.12)',
  lineSoft: 'rgba(16,24,32,.07)',
  muted: 'rgba(16,24,32,.62)',
  gold: '#c9a35c',
  radius: 8,
  serif: '"Fraunces", Georgia, serif',
  sans: '"Instrument Sans", "Helvetica Neue", Arial, sans-serif',
  shadowLg: '0 24px 60px -24px rgba(16,24,32,.35)',
  shadowSm: '0 1px 0 rgba(16,24,32,.05), 0 10px 30px -18px rgba(16,24,32,.25)',
};
